import repository from '@/repositories/Repository'

const resource = '/api/upload_file'

const validDataType = new Set(['journal', 'item', 'customer'])

export default {
  issueUploadUrl(filename) {
    return repository.http
      .post(`${resource}`, filename, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(r => r.data)
  },
  upload(url, file, dataType, onUploadProgress) {
    if (!validDataType.has(dataType)) {
      throw new Error(`Not a valid data type: ${dataType}`)
    }

    return repository.rawHttp
      .put(url, file, {
        headers: { 'Content-Type': 'application/octet-stream' },
        onUploadProgress,
      })
      .then(r => r.data)
  },
  loadFile(id, dataType) {
    if (!validDataType.has(dataType)) {
      throw new Error(`Not a valid data type: ${dataType}`)
    }

    return repository.http
      .post(`${resource}/${dataType}/${id}`, undefined, {
        headers: { 'Content-Type': 'application/octet-stream' },
      })
      .then(r => r.data)
  },
  fetchFile(id, dataType) {
    if (!validDataType.has(dataType)) {
      throw new Error(`Not a valid data type: ${dataType}`)
    }

    return repository.http
      .get(`${resource}/${dataType}/${id}`, undefined, {
        headers: { 'Content-Type': 'application/octet-stream' },
      })
      .then(r => r.data)
  },
  fetchFiles(dataType) {
    if (!validDataType.has(dataType)) {
      throw new Error(`Not a valid data type: ${dataType}`)
    }

    return repository.http
      .get(`${resource}/${dataType}`, undefined, {
        headers: { 'Content-Type': 'application/octet-stream' },
      })
      .then(r => r.data)
  },
}
